import React from 'react'

/* STYLES */
import * as styles from './sideBarReceitas.module.scss'

/* ICONS */
import search from '../../../images/receitas/search.svg'
import { navigate } from 'gatsby'

const InputSearch = () => {
  function handleSearchReceitas (event) {
    event.preventDefault()
    navigate(`/receitas/busca?q=${event.target[0].value}`)
  }

  return (
    <div className='position-relative mb-4'>
      <form onSubmit={(e) => handleSearchReceitas(e)}>
        <label htmlFor='pesquisa' className='sr-only'>Pesquisa</label>
        <input
          type='text'
          id='pesquisa'
          name='pesquisa'
          className={`${styles.inputReceita} px-3 w-100`}
          placeholder='Procurar receita'
        />
        <img src={search} className={`position-absolute ${styles.searchIcon}`} alt='Icone Pesquisa' />
      </form>
    </div>
  )
}

export default InputSearch
